/**
 * WhatsApp-style dark theme tokens (Tailwind `wa` palette).
 * Use these class fragments in className / classNames().
 */
export const wa = {
  app: "bg-wa-app",
  panel: "bg-wa-panel",
  panel2: "bg-wa-panel2",
  border: "border-wa-border",
  hover: "hover:bg-wa-hover",
  active: "bg-wa-hover",
  text: "text-wa-text",
  muted: "text-wa-muted",
  accent: "text-wa-accent",
  bubbleOut: "bg-wa-accentdeep",
  bubbleIn: "bg-wa-panel2",
  input: "bg-wa-hover text-wa-text placeholder:text-wa-muted",
  badge: "bg-wa-accent text-wa-onaccent",
};
